<template>
     <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger as-child>
            <SidebarMenuButton
              size="lg"
              class="text-sidebar-foreground data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div
                class="h-8 w-8 shrink-0 cursor-pointer "
            >
                <img
                    :src="
                        current.profile_photo_path
                            ? current.profile_photo_path
                            : current.profile_photo_url
                    "
                    class="h-8 w-8  bg-white object-cover"
                />
            </div>
              <div class="grid flex-1 text-left text-sm leading-tight">
                <span class="truncate font-semibold">
                    {{ current.name }}
                </span>
                <span class="truncate text-xs">{{ teamProps.personal_team ? 'Personal account' : 'Team' }}</span>
              </div>
              <ChevronsUpDown class="ml-auto" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            class="w-[--radix-dropdown-menu-trigger-width] min-w-56 "
            align="start"
            :side="isMobile ? 'bottom' : 'right'"
            :side-offset="4"
          >
           <DropdownMenuLabel class="text-xs text-muted-foreground">
              Personal account
            </DropdownMenuLabel>
 
              <DropdownMenuItem
              class="gap-2 p-2"
                @click="switchToPersonalTeam"
              >
                <div
                class="h-8 w-8 shrink-0 cursor-pointer "
                >
                    <img
                        :src="
                              userProps.profile_photo_path
                                  ? userProps.profile_photo_path
                                  : userProps.profile_photo_url
                          "
                        class="h-8 w-8  bg-white object-cover"
                    />
                </div>
                {{ userProps.name }}
              </DropdownMenuItem>

          <DropdownMenuSeparator />

          <DropdownMenuGroup v-if="filteredTeamData.length">
            <DropdownMenuLabel class="text-xs text-muted-foreground">
              Teams
            </DropdownMenuLabel>
            
              <DropdownMenuItem
                v-for="(team, index) in filteredTeamData"
                :key="index"
                class="gap-2 p-2"
                @click="switchTeam(team.id)"
              >
                <div
                class="h-8 w-8 shrink-0 cursor-pointer "
                >
                    <img
                        :src="
                                            team.profile_photo_path
                                                ? team.profile_photo_path
                                                : team.profile_photo_url
                                        "
                        class="h-8 w-8  bg-white object-cover"
                    />
                </div>
                {{ team.name }}

              <Badge  v-if="team.user_id === userProps.id">owner</Badge>
              </DropdownMenuItem>
          </DropdownMenuGroup>
    
            <DropdownMenuSeparator v-if="filteredTeamData.length" />
            <DropdownMenuItem class="gap-2 p-2" @select.prevent @click="openDialog = true">
              <div class="flex size-6 items-center justify-center border bg-background">
                <Plus class="size-4" />
              </div>
              <div class="font-medium text-muted-foreground">Create team</div>
            </DropdownMenuItem>

            <DropdownMenuSeparator />
            <DropdownMenuItem class="gap-2 p-2" @click="logout">
              <div class="flex size-6 items-center justify-center">
                <LogOut class="size-4 text-muted-foreground" />
              </div>
              <div class="font-medium text-muted-foreground">Log out</div>
            </DropdownMenuItem>

            <CreateTeamModalV2
:open="openDialog"
    @update:open="openDialog = $event" @team-created="fetchTeams" />
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
    </template>

    <script lang="ts" setup>
import { ChevronsUpDown, LogOut, Plus } from 'lucide-vue-next';
import { useSidebar } from './utils';
import { Badge } from '@/components/ui/badge'
import ICurrentTeam from '@/types/Members/ICurrentTeam';
import IUser from '@/types/Members/IUser';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';


const globalProps = computed(() => usePage<ITopolPageProps>().props);
const userProps = computed(() => globalProps.value.user as IUser);
const teamProps = computed(() => globalProps.value.team as ICurrentTeam);

const openDialog = ref(false);

const { isMobile } = useSidebar()

const { fetchTeams, getCurrentTeamMembersCount, allTeams } =
    useTeamsAndMembers();
const { fetchBanners, fetchPaymentRequestData } = useBanners();
const { fetchSubscriptions } = useSubscriptions();
const { resetCurrentFolderWithoutFetching } = useFolders();

const switchTeam = (teamId: number) => {
    if (teamProps.value.id === teamId) {
        // isOpen.value = false;
    } else {
        resetCurrentFolderWithoutFetching();
        router.post(route('teams.switch.store'), {
          id: teamId
        }, {
            onSuccess: () => {
                // isOpen.value = false;
                handleFetchBannersAndMembers();
            },
        });
    }
};

const handleFetchBannersAndMembers = () => {
    fetchSubscriptions();
    fetchBanners();
    fetchPaymentRequestData();
    getCurrentTeamMembersCount();
};

const current = computed(() => {
    if (
        teamProps.value.personal_team &&
        teamProps.value.owner_id === userProps.value.id
    ) {
        return userProps.value;
    }
    return teamProps.value;
});

const switchToPersonalTeam = () => {
    const personalTeam = allTeams.value.find(
        (team) => team.personal_team === true
    );
    if (!personalTeam) return;
    switchTeam(personalTeam.id);
};

const logout = () => {
    router.post(route('logout'));
};

const filteredTeamData = computed(() => {
    return allTeams.value.filter(
        (team) => !(team.personal_team && team.owner_id === userProps.value.id)
    );
});

</script>